import { action, atom } from '@reatom/framework'
import i18next from 'i18next'

import {
  languageSelectionAtom,
  setLanguageAction,
  systemLanguageAtom,
  type Lang,
  type LanguageSelection,
} from '@root/shared/localization'
import { showSnackbarAction } from '@root/shared/ui-kit'

import * as ChangeLanguageState from '../model/change-language-state'

export const changeLanguageStateAtom =
  atom<ChangeLanguageState.ChangeLanguageState>(
    new ChangeLanguageState.ChangeLanguageStateDone(),
    'changeLanguageStateAtom',
  )

export const changeLanguageAction = action(
  async (ctx, lang: Lang.Lang | undefined) => {
    const languageSelection = ctx.get(languageSelectionAtom)
    const systemLanguage = ctx.get(systemLanguageAtom)

    const newSelection: LanguageSelection | undefined = (() => {
      if (lang) {
        return { type: 'manual', lang: lang }
      }
      if (systemLanguage) {
        return { type: 'system', lang: systemLanguage }
      }
      return undefined
    })()

    if (!newSelection) {
      return
    }

    if (
      newSelection.lang === languageSelection.lang &&
      newSelection.type === languageSelection.type
    ) {
      return
    }
    changeLanguageStateAtom(
      ctx,
      new ChangeLanguageState.ChangeLanguageStateLoading({
        lang: newSelection.lang,
      }),
    )
    await ctx.schedule(() => setLanguageAction(ctx, newSelection))
    changeLanguageStateAtom(
      ctx,
      new ChangeLanguageState.ChangeLanguageStateDone(),
    )

    showSnackbarAction(ctx, {
      text: i18next.t('settings.language.change-successful'),
      intent: 'success',
    })
  },
  'changeLanguageAction',
)
